import type { HubCapsule } from '@aws-amplify/core';

// need the Hub Listener to detect auth events to trigger rerenders
export const AuthListener = async (
  data: HubCapsule,
  setupSession: (customState?: string) => Promise<void>,
  setSessionLoading: (loading: boolean) => void,
  takedownSession: () => Promise<void>,
  captureAuthEvent: (event: 'tokenRefresh' | 'tokenRefresh_failure') => void
): Promise<void> => {
  setSessionLoading(true);

  switch (data.payload.event) {
    case 'signIn':
      await setupSession();
      break;
    case 'signUp':
      break;
    case 'signOut':
      await takedownSession();
      break;
    case 'signIn_failure':
      break;
    case 'configured':
      break;
    case 'autoSignIn':
      break;
    case 'autoSignIn_failure':
      break;
    case 'confirmSignUp':
      break;
    case 'forgotPassword':
      break;
    case 'forgotPassword_failure':
      break;
    case 'forgotPasswordSubmit':
      break;
    case 'forgotPasswordSubmit_failure':
      break;
    case 'customOAuthState':
      await setupSession(data?.payload?.data);
      break;
    case 'tokenRefresh':
      captureAuthEvent('tokenRefresh');
      await setupSession();
      break;
    case 'tokenRefresh_failure':
      captureAuthEvent('tokenRefresh_failure');
      await takedownSession();
      break;
    default:
      break;
  }

  setSessionLoading(false);
};
